import axios from 'axios';

export default function () {
  const baseUrl = document.querySelector('meta[name=ax-base-url]').content;
  const authToken = document.querySelector('meta[name=ax-auth-token]').content;

  axios.defaults.baseURL = baseUrl;
  axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common.Accept = 'application/json';

  // Act as the profile this page rendered as, not whichever one the user last
  // switched to (possibly in another tab). See shared/_axios_setup.html.erb.
  const profileId = document.querySelector('meta[name=ax-profile-id]');
  const profileType = document.querySelector('meta[name=ax-profile-type]');
  if (profileId && profileType) {
    axios.defaults.headers.common['X-WIQ-Profile-Id'] = profileId.content;
    axios.defaults.headers.common['X-WIQ-Profile-Type'] = profileType.content;
  }
}
